import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductCpService {

  private url = environment.api + "api/erp/products-cp";

  constructor(
    private http: HttpClient,
  ) { }

  createProductCP(data: any) {
    return this.http.post(this.url, data);
  }

  getAssigProviderProductParameters(searchValue: any) {
      return this.http.get(this.url + ``,
        {
          params: {
            searchValue: searchValue,
          }
        }
      );
    }

  getIsExisteAssign(vendorId: any, productId: any) {
    return this.http.get(this.url + `/vendors/${vendorId}/products/${productId}`);
  }

  deleteProductCPById(productCPId: any) {
    return this.http.delete(this.url + `/${productCPId}`);
  }

  getProducsCPByVendorId(vendorId: any) {
    return this.http.get(this.url + `/products-by-vendor/${vendorId}`);
  }
}
